import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_DatePager = _resolveComponent("DatePager")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_OtherRecord = _resolveComponent("OtherRecord")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_ChildDiary = _resolveComponent("ChildDiary")!
  const _component_EatingRecord = _resolveComponent("EatingRecord")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_VueLoading = _resolveComponent("VueLoading")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_locale_provider = _resolveComponent("v-locale-provider")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.clas && !_ctx.fetchLoading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_v_app_bar, {
            color: "primary",
            flat: "",
            app: "",
            dark: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_app_bar_nav_icon, {
                style: {"position":"absolute"},
                onClick: _ctx.goBackWithTab
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    large: "",
                    color: "white"
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode("mdi-chevron-left", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_app_bar_title, { style: {"min-width":"fit-content","font-size":"14px"} }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.clas.className), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_spacer),
              (_ctx.shouldShowClassDiary)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    style: {"position":"absolute","right":"0"},
                    color: "#FFFFFF",
                    depressed: "",
                    onClick: _ctx.toClassDiary
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("クラス日誌", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.showLoader)
            ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                key: 0,
                indeterminate: "",
                color: "primary",
                height: "3"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openDialog && _ctx.openDialog(...args)))
          }, [
            _createVNode(_component_DatePager, {
              date: _ctx.date,
              onAddDay: _ctx.addDay,
              onSubtractDay: _ctx.subtractDay
            }, null, 8, ["date", "onAddDay", "onSubtractDay"])
          ]),
          _createVNode(_component_v_tabs, {
            modelValue: _ctx.tabIndex,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tabIndex) = $event)),
            color: "primary",
            grow: ""
          }, {
            default: _withCtx(() => [
              (_ctx.shouldShowRecords)
                ? (_openBlock(), _createBlock(_component_v_tab, { key: 0 }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode("記録", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.shouldShowDiary)
                ? (_openBlock(), _createBlock(_component_v_tab, { key: 1 }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode("日誌", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.shouldShowMeal)
                ? (_openBlock(), _createBlock(_component_v_tab, { key: 2 }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode("喫食", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (_ctx.children)
            ? (_openBlock(), _createBlock(_component_v_window, {
                key: 1,
                modelValue: _ctx.tabIndex,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tabIndex) = $event))
              }, {
                default: _withCtx(() => [
                  (_ctx.shouldShowRecords)
                    ? (_openBlock(), _createBlock(_component_v_window_item, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_OtherRecord, {
                            children: _ctx.children,
                            clas: _ctx.clas,
                            date: _ctx.date
                          }, null, 8, ["children", "clas", "date"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.shouldShowDiary)
                    ? (_openBlock(), _createBlock(_component_v_window_item, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ChildDiary, {
                            diaries: _ctx.diaries,
                            children: _ctx.children,
                            clas: _ctx.clas,
                            absenceAttendance: _ctx.absenceAttendance,
                            date: _ctx.date
                          }, null, 8, ["diaries", "children", "clas", "absenceAttendance", "date"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.shouldShowMeal)
                    ? (_openBlock(), _createBlock(_component_v_window_item, { key: 2 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_EatingRecord, {
                            children: _ctx.children,
                            clas: _ctx.clas,
                            date: _ctx.date
                          }, null, 8, ["children", "clas", "date"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createBlock(_component_VueLoading, {
          key: 1,
          height: '50vh'
        })),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialogFlg,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogFlg) = $event)),
      width: "auto"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_locale_provider, { locale: "ja" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_date_picker, {
              modelValue: _ctx.selectedDate,
              "onUpdate:modelValue": [
                _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedDate) = $event)),
                _ctx.dateSelected
              ],
              type: "date",
              "day-format": (date) => new Date(date).getDate(),
              "no-title": "",
              "hide-header": "",
              color: "primary",
              style: {"transform":"scale(0.8)"}
            }, null, 8, ["modelValue", "day-format", "onUpdate:modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}